

































































































































import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { NavigationGuardNext, Route } from 'vue-router';
import { ValidationObserver } from 'vee-validate';
import EditorActionMixin from '@/mixins/editor-action';
import ApiStatusMixin from '@/mixins/api-status';
import ApiErrorMixin from '@/mixins/api-error';
import { StatusOption, statusOptions } from '@/configs/status';
import SingleImageUploader from '@/components/SingleImageUploader.vue';
import { BannerDetail } from '@/models/banner';
import { postBanner, getBannerDetail, postBannerDetail } from '@/configs/api-path';
import sleep from '@/utils/sleep';

// interface HTMLFileInputEvent extends Event {
//   target: HTMLInputElement & EventTarget;
// }

// export interface ImageUploaderPreview {
//   path: string | ArrayBuffer | null;
//   filename: string;
//   date?: string | number | Date | null;
// }

Component.registerHooks([
  'beforeRouteLeave',
]);

const extendStoreErrorMessage = {
  441: '檔案格式錯誤',
  442: '檔案尺寸錯誤',
  443: '檔案大小超過限制',
};

@Component({
  components: {
    SingleImageUploader,
  },
})
export default class PageBannerEdit extends mixins(
  EditorActionMixin, ApiStatusMixin, ApiErrorMixin,
) {
  $refs!: {
    formObs: InstanceType<typeof ValidationObserver>;
  }

  statusOptions: StatusOption[] = statusOptions;

  bannerId: number | null = null;

  bannerForm: BannerDetail = {
    web_content: '',
    mobile_content: '',
    web_photo: null,
    web_photo_name: null,
    web_photo_path: null,
    pad_photo: null,
    pad_photo_name: null,
    pad_photo_path: null,
    mobile_photo: null,
    mobile_photo_name: null,
    mobile_photo_path: null,
    status: false,
  };

  get headingTitle() {
    return this.isCreateAction ? '新增' : '編輯';
  }

  get basicTitle() {
    return this.isCreateAction ? '新增輪播' : '編輯輪播';
  }

  // eslint-disable-next-line class-methods-use-this
  get breadcrumb() {
    return [
      {
        text: '首頁管理',
        to: null,
      },
      {
        text: '輪播管理',
        to: null,
      },
      // {
      //   text: this.basicTitle,
      //   to: null,
      // },
    ];
  }

  get submitText() {
    return this.isCreateAction ? '新增' : '儲存';
  }

  get isFormChanged() {
    return this.$refs.formObs.flags.changed;
  }

  get webPhoto() {
    return {
      file: this.bannerForm.web_photo,
      previewPath: this.bannerForm.web_photo_path,
      previewFilename: this.bannerForm.web_photo_name,
    };
  }

  set webPhoto(val) {
    this.bannerForm.web_photo = val.file;
    this.bannerForm.web_photo_path = val.previewPath;
    this.bannerForm.web_photo_name = val.previewFilename;
  }

  get padPhoto() {
    return {
      file: this.bannerForm.pad_photo,
      previewPath: this.bannerForm.pad_photo_path,
      previewFilename: this.bannerForm.pad_photo_name,
    };
  }

  set padPhoto(val) {
    this.bannerForm.pad_photo = val.file;
    this.bannerForm.pad_photo_path = val.previewPath;
    this.bannerForm.pad_photo_name = val.previewFilename;
  }

  get mobilePhoto() {
    return {
      file: this.bannerForm.mobile_photo,
      previewPath: this.bannerForm.mobile_photo_path,
      previewFilename: this.bannerForm.mobile_photo_name,
    };
  }

  set mobilePhoto(val) {
    this.bannerForm.mobile_photo = val.file;
    this.bannerForm.mobile_photo_path = val.previewPath;
    this.bannerForm.mobile_photo_name = val.previewFilename;
  }

  cancelEdit() {
    this.$router.push({
      name: 'banner-list',
    });
  }

  beforeRouteLeave(to: Route, from: Route, next: NavigationGuardNext) {
    if (this.isFormChanged) {
      // eslint-disable-next-line no-alert
      const confirm = window.confirm(`確定取消${this.headingTitle}？\n離開後變更的資料將不會被儲存。`);

      if (confirm === false) {
        return;
      }
      next();
      return;
    }
    next();
  }

  async fetchBanner() {
    this.setApiLoading();
    try {
      const { bannerId } = this.$route.params;
      const { data: bannerResponse } = await this.$axios.get<{
        code: number;
        banner: BannerDetail;
      }>(getBannerDetail(bannerId));

      if (bannerResponse.code === 0) {
        this.bannerId = parseInt(bannerId, 10);
        this.bannerForm.web_content = bannerResponse.banner.web_content;
        this.bannerForm.mobile_content = bannerResponse.banner.mobile_content;
        this.bannerForm.web_photo_name = bannerResponse.banner.web_photo_name;
        this.bannerForm.web_photo_path = bannerResponse.banner.web_photo_path;
        this.bannerForm.pad_photo_name = bannerResponse.banner.pad_photo_name;
        this.bannerForm.pad_photo_path = bannerResponse.banner.pad_photo_path;
        this.bannerForm.mobile_photo_name = bannerResponse.banner.mobile_photo_name;
        this.bannerForm.mobile_photo_path = bannerResponse.banner.mobile_photo_path;
        this.bannerForm.status = bannerResponse.banner.status;
      } else {
        this.apiErrorCodeAlert(bannerResponse.code, '編輯輪播');
        this.$router.replace({
          name: 'banner-list',
        });
      }
    } catch (error) {
      console.error(error);
    }

    this.$refs.formObs.reset();
    this.setApiPending();
  }

  bannerSubmit() {
    if (this.isCreateAction) {
      this.createBannerHandler();
    } else if (this.isEditAction) {
      this.editBannerHandler();
    }
  }

  generateFormData() {
    const formData = new FormData();
    const formInfo = {
      web_content: this.bannerForm.web_content,
      mobile_content: this.bannerForm.mobile_content,
    };

    formData.append('info', JSON.stringify(formInfo));

    if (this.bannerForm.web_photo) {
      formData.append('web_photo', this.bannerForm.web_photo);
    }

    if (this.bannerForm.pad_photo) {
      formData.append('pad_photo', this.bannerForm.pad_photo);
    }

    if (this.bannerForm.mobile_photo) {
      formData.append('mobile_photo', this.bannerForm.mobile_photo);
    }

    return formData;
  }

  async createBannerHandler() {
    this.setApiLoading();
    try {
      const formData = this.generateFormData();

      const { data: submitBannerResponse } = await this.$axios.post<{
        code: number;
        banner: number;
      }>(postBanner, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (submitBannerResponse.code === 0) {
        this.$refs.formObs.reset();
        await sleep(0.1);
        this.$notify.show('success filled', '輪播已新增！', '新增輪播', { duration: 3000, permanent: false });
        this.$router.push({
          name: 'banner-list',
        });
      } else {
        this.apiErrorCodeAlert(submitBannerResponse.code, '新增輪播', extendStoreErrorMessage);
      }
    } catch (error) {
      console.error(error);
    }
    this.setApiPending();
  }

  async editBannerHandler() {
    if (!this.bannerId) {
      return;
    }

    this.setApiLoading();
    try {
      const formData = this.generateFormData();

      const { data: submitBannerResponse } = await this.$axios.post<{
        code: number;
        banner: number;
      }>(postBannerDetail(this.bannerId), formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (submitBannerResponse.code === 0) {
        this.$refs.formObs.reset();
        await sleep(0.1);
        this.$notify.show('success filled', `輪播 #${this.bannerId} 已更新！`, '更新輪播', { duration: 3000, permanent: false });
        this.$router.push({
          name: 'banner-list',
        });
      } else {
        this.apiErrorCodeAlert(submitBannerResponse.code, '更新輪播', extendStoreErrorMessage);
      }
    } catch (error) {
      this.$notify.show(
        'error filled',
        `更新輪播 #${this.bannerId} 時發生錯誤。`,
        '更新輪播',
        { duration: 3000, permanent: false },
      );
      console.error(error);
    }
    this.setApiPending();
  }

  beforeMount() {
    if (this.editorAction && this.$route.params.bannerId) {
      this.fetchBanner();
    }
  }
}
